

































import { LoadingStatusType } from "@/enums/enums";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreTransaction = namespace("Transaction");

@Component
export default class ModalCreateTag extends Vue {
  private tagName = "";
  private hiddenModal = false;
  private validateTagName = false;

  @StoreTransaction.Getter
  private getCreateNewTagLoadingStatus!: LoadingStatusType;

  @StoreTransaction.Action
  private DoCreateNewTag!: (input: any) => void;

  @Watch("getCreateNewTagLoadingStatus")
  getCreateNewTagLoadingStatusChanged() {
    this.$emit("update:showModal", false);
  }

  public CreateNewTag() {
    if (!this.validateTagName && this.tagName !== "") {
      const input = {
        tagName: this.tagName,
        tagId: 0,
      };
      this.DoCreateNewTag(input);
    }
  }

  public HiddenModal() {
    this.hiddenModal = true;
    this.$emit("update:showModal", false);
    setTimeout(() => {
      this.hiddenModal = false;
    }, 300);
  }
}
